import { TextArea } from '@e2n/ui/v2';
import { cn } from '@/lib/utils';
import { FieldBase } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/FieldBase';
import { FieldProps } from '@/domain/mitarbeiter/features/anlageassistent/components/form/types';
import { useFieldContext } from '@/domain/mitarbeiter/features/anlageassistent/components/form/hooks';

export function TextAreaInput({
  label,
  description,
  placeholder,
  className,
  isRequired,
  showCounter,
  maxLength,
  ...props
}: FieldProps & React.ComponentProps<'textarea'> & { showCounter?: boolean }) {
  const field = useFieldContext<string>();
  return (
    <FieldBase label={label} description={description} isRequired={isRequired}>
      <TextArea
        id={field.name}
        name={field.name}
        className={cn(
          'border border-neutrals-300 min-h-21',
          'ring-0 ring-offset-0 focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0',
          'outline-hidden focus:outline-hidden shadow-none',
          className,
        )}
        placeholder={placeholder}
        value={field.state.value ?? ''}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        showCount={showCounter}
        maxLength={maxLength}
        {...props}
      />
    </FieldBase>
  );
}
